import PropTypes from 'prop-types'

const DeleteNotificationIcon = ({ className }: { className: string }) => (
  <svg
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Builder/-Operation/-Delete-Notification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-2" transform="translate(1.000000, 5.000000)" fill="#1A56DB" fillRule="nonzero">
        <path
          d="M34.626849,0 C28.3456312,0 23.253698,5.09193314 23.253698,11.373151 C23.253698,17.6543688 28.3456312,22.746302 34.626849,22.746302 C40.9080669,22.746302 46,17.6543688 46,11.373151 C46,5.09193314 40.9080669,0 34.626849,0 Z M40.0661821,14.8345448 L38.0882428,16.8124841 L34.626849,13.3510903 L31.1654552,16.8124841 L29.1875159,14.8345448 L32.6489097,11.373151 L29.1875159,7.9117572 L31.1654552,5.9338179 L34.626849,9.39521168 L38.0882428,5.9338179 L40.0661821,7.9117572 L36.6047883,11.373151 L40.0661821,14.8345448 Z"
          id="Shape"
        ></path>
        <g id="mobile-chat-copy-2" transform="translate(0.000000, 4.650740)">
          <path
            d="M21.8396899,0 C21.5865387,0.312493531 21.3534615,0.740186296 21.1404584,1.2830783 C20.9274552,1.8259703 20.7550406,2.43177522 20.6232144,3.10049307 L5.36623801,3.10049307 C4.19477736,3.10049307 3.18774984,4.13856112 3.10586467,5.50429787 L3.10049307,5.6842373 L3.10049307,29.8821133 C3.10049307,30.0125466 3.14981824,30.1381549 3.23857173,30.2337356 C3.41119008,30.4196323 3.6887111,30.4498556 3.89513268,30.3178871 L3.96886424,30.2607834 L10.8789576,24.8039446 L30.8061812,24.8039446 C31.9776418,24.8039446 32.9846693,23.7658765 33.0665545,22.4001398 L33.0719261,22.2202003 L33.0719261,21.1110136 C33.7404559,21.161473 34.3047322,21.1867027 34.7647548,21.1867027 C35.2247774,21.1867027 35.6939989,21.161473 36.1724192,21.1110136 L36.1724192,22.2202003 C36.1724192,25.2552126 33.9160119,27.775529 31.0294406,27.899648 L30.8061812,27.9044376 L12.096057,27.9044376 L6.07859816,32.5328046 C4.6669452,33.8436252 2.4883496,33.8116188 1.11567368,32.4950394 L0.966550583,32.3434695 C0.397049047,31.7301601 0.0594626844,30.9402298 0.00715316234,30.1095658 L0,29.8821133 L0,5.6842373 C0,2.64922509 2.25640724,0.128908606 5.14297855,0.00478966462 L5.36623801,0 L21.8396899,0 Z"
            id="Path"
          ></path>
          <path
            d="M17.0527119,17.0527119 C17.9088894,17.0527119 18.6029584,17.7467809 18.6029584,18.6029584 C18.6029584,19.4087726 17.988143,20.0709889 17.202011,20.1461084 L17.0527119,20.153205 L9.81822806,20.153205 C8.96205054,20.153205 8.26798152,19.4591359 8.26798152,18.6029584 C8.26798152,17.7971443 8.88279698,17.134928 9.66892897,17.0598085 L9.81822806,17.0527119 L17.0527119,17.0527119 Z"
            id="Path"
          ></path>
          <path
            d="M21.0970539,11.8852234 C18.5810027,11.8852234 14.8213941,11.8852234 9.81822806,11.8852234 C8.96205054,11.8852234 8.26798152,11.1911544 8.26798152,10.3349769 C8.26798152,9.52916277 8.88279698,8.86694648 9.66892897,8.79182696 L9.81822806,8.78473037 C14.4593129,8.78473037 17.9662563,8.78473037 20.3390581,8.78473037 C20.3390581,9.63829188 20.7478813,10.8719156 21.0970539,11.8852234 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

DeleteNotificationIcon.displayName = 'DeleteNotificationIcon'

DeleteNotificationIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

DeleteNotificationIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default DeleteNotificationIcon
